import { CSSProperties, useEffect, useState } from "react";
import CSS from "csstype";
import "./ResultsSequence.css";
import { Colors } from "../../routes/OldLobby/Colors";
import Button from "../Button/Button";
import { Flipper, Flipped, spring } from "react-flip-toolkit";
import { Cue } from "../../shared/interfaces/GameLogicTypes";
import { Stack, Box, Typography, Paper } from "@mui/material";
import { getColorStylebyNumber, getFontSizeByAnswer } from "../../shared/helper/functions";
import { renderCueContent } from "../../shared/helper/renderCueContent";

export const Positions = {};

export interface ResultsSequenceProps {
  inputSequence: number[];
  playerName: String;

  score?: number;
  style?: CSSProperties;
  ballStyle?: CSSProperties;
  tsarDisplay?: boolean;
  cues: Cue[];
  // Optional: override overall width for embedding
  width?: string | number;
  // Compact mode: name beside bar, shorter cards
  compact?: boolean;
  // Hide the player name label
  hideName?: boolean;
  //swaps: Array<number|number[]>;
}

export default function ResultsSequence(props: ResultsSequenceProps) {
  //full on gray
  const [sequence, setSequence] = useState<number[]>([]);

  useEffect(() => {
    if (props.inputSequence.length == 5) {
      setSequence(props.inputSequence);
    }
  }, [props.inputSequence]);

  // Compact (inline results): bar fills parent, cards are short (3/4 aspect)
  // so two bars + score row + button fit in ~448px panel.
  // Full (backdrop): bar is 40-50vw, cards are taller (11/16 aspect).
  const barWidth = props.width ?? (props.compact ? "100%" : { lg: "40vw", md: "50vw" });
  const cardAspect = props.compact ? "3/4" : "11/16";

  return (
    <Stack
      id="ResultsSequence"
      justifyContent="space-between"
      alignItems={props.compact ? "center" : "center"}
      direction={props.compact ? "row" : "column"}
      spacing={props.compact ? 1 : 0}
      sx={{ width: props.compact ? "100%" : (props.width ?? { lg: "40vw", md: "50vw" }) }}
    >
      {!props.hideName && (
        <Typography
          textAlign={"left"}
          variant={props.compact ? "body2" : "h4"}
          noWrap={props.compact}
          sx={props.compact ? { minWidth: "4.5em", maxWidth: "6em", flexShrink: 0 } : { width: "90%", mb: 0.5 }}
        >
          {props.playerName}
        </Typography>
      )}
      <Box sx={props.compact ? { flex: 1, minWidth: 0 } : undefined}>
      <Flipper spring={{ stiffness: 280, damping: 22 }} flipKey={sequence.join("")}>
        <Paper
          sx={{
            width: barWidth,
          }}
        >
          <Stack
            direction={"row"}
            justifyContent="space-evenly"
            alignItems={"center"}
            sx={{
              width: "calc(100% -.4em)",
              height: "100%",
              paddingBlock: props.compact ? ".15em" : { md: ".4em", lg: ".5em" },
              paddingInline: ".2em",
            }}
          >
            {sequence.map((d: number) => (
              <Flipped key={d} flipId={d} translate={true}>
                <Paper
                  sx={{
                    width: props.compact ? "18%" : { md: "16%", lg: "17%" },
                    aspectRatio: cardAspect,
                    backgroundColor: getColorStylebyNumber(d),
                    overflow: "hidden",
                  }}
                >
                  {d != 0 ? (
                    <Typography
                      variant="body1"
                      sx={{
                        margin: ".2em",
                        fontSize: getFontSizeByAnswer(props.cues[d - 1].content),
                        overflow: "hidden",
                        display: "-webkit-box",
                        WebkitLineClamp: props.compact ? 3 : 4,
                        WebkitBoxOrient: "vertical",
                        wordBreak: "break-word",
                      }}
                    >
                      {renderCueContent(String(props.cues[d - 1].content))}
                    </Typography>
                  ) : (
                    <></>
                  )}
                </Paper>
              </Flipped>
            ))}
          </Stack>
        </Paper>
      </Flipper>
      </Box>
    </Stack>
  );
}

// export function getBallGetterSetter(index: number) {
//   switch (index) {
//     case 1: {
//         return (()=>setBall1Pos());
//       }
//     }
//   }
